import { tt } from '@agos/shared'

/**
 * The rights the stock and supplier screens' main-administrator writes ask - `FRONTEND.md` §9.758, `BACKEND.md`
 * §10A.413 (owner, folded into O119).
 *
 * <p>Three writes were `@RequireAuth("main_admin")` and offered to every visitor, because nothing asked anything:
 * reading a photographed delivery note (`POST /stock/receipts/ocr`), filling suppliers in from receipts (`POST
 * /suppliers/backfill-from-receipts`) and deleting a supplier (`DELETE /suppliers/{id}`). §10A.413 opens each to a write
 * key **alone** - `stock` and `suppliers`, the screens' own keys, are held by Nesvady's *Čašník*, and pairing `stock`
 * with `stock_edit` would hand them a metered call. Asked through `hasPermission`, true for the main administrator.
 *
 * <p>The receipt itself, a supplier's create, edit and switch are the server's `stock`/`stock_edit` and
 * `{main_admin, admin}` rules and are not touched here.
 */
export const STOCK_EDIT = 'stock_edit'
export const SUPPLIERS_EDIT = 'suppliers_edit'
export const SUPPLIERS_DELETE = 'suppliers_delete'

/** Which of *Dodávatelia*' two main-administrator actions this person is offered. */
export interface SupplierActions {
  /** *Doplniť z faktúr* - `POST /suppliers/backfill-from-receipts`. */
  backfill: boolean
  /** *Zmazať* on a supplier - `DELETE /suppliers/{id}`. */
  delete: boolean
}

export function supplierActionsFor(hasPermission: (permission: string) => boolean): SupplierActions {
  return { backfill: hasPermission(SUPPLIERS_EDIT), delete: hasPermission(SUPPLIERS_DELETE) }
}

/** Whether a photograph may be read - the vision model is metered, which is why the right is the write key alone. */
export function mayReadPhotoFor(hasPermission: (permission: string) => boolean): boolean {
  return hasPermission(STOCK_EDIT)
}

/** Said in the receipt dialog to somebody who may not have a photograph read - the right, under its roles-screen label. */
export function photoRightNote(): string {
  return `${tt('Čítanie z fotky je spoplatnené a spustí ho len ten, kto má právo')} „${tt('Skladové hospodárstvo - Upraviť')}“. ${tt('PDF faktúru načítate aj bez neho.')}`
}
